// ----------------------
// <auto-generated>
// Generated by PermissionsGenerator.
// </auto-generated>
// ----------------------

export class AdministrationPermissions {
    static _ = 'Administration';

    static User = class {
        static _ = 'Administration.User';

        static ViewAll = 'Administration.User.ViewAll';
        static ViewOwn = 'Administration.User.ViewOwn';
        static Edit = 'Administration.User.Edit';
        static Create = 'Administration.User.Create';
    };

    static Role = class {
        static _ = 'Administration.Role';

        static ViewAll = 'Administration.Role.ViewAll';
        static ViewOwn = 'Administration.Role.ViewOwn';
        static Edit = 'Administration.Role.Edit';
        static Create = 'Administration.Role.Create';
    };

    static Organization = class {
        static _ = 'Administration.Organization';

        static ViewAll = 'Administration.Organization.ViewAll';
        static ViewOwn = 'Administration.Organization.ViewOwn';
        static Edit = 'Administration.Organization.Edit';
        static Create = 'Administration.Organization.Create';
    };

    static Settings = class {
        static _ = 'Administration.Settings';

        static View = 'Administration.Settings.View';
        static Edit = 'Administration.Settings.Edit';
    };
}

export class CodeListPermissions {
    static _ = 'CodeList';

    static Action = class {
        static _ = 'CodeList.Action';

        static Create = 'CodeList.Action.Create';
        static Delete = 'CodeList.Action.Delete';
        static Edit = 'CodeList.Action.Edit';
    };

    static View = class {
        static _ = 'CodeList.View';

        static Item = 'CodeList.View.Item';
        static List = 'CodeList.View.List';
    };
}

export class FaqPermissions {
    static _ = 'Faq';

    static Action = class {
        static _ = 'Faq.Action';

        static Save = 'Faq.Action.Save';
        static Delete = 'Faq.Action.Delete';
    };

    static View = class {
        static _ = 'Faq.View';

        static List = 'Faq.View.List';
    };
}

export class NoticeBoardPermissions {
    static _ = 'NoticeBoard';

    static Action = class {
        static _ = 'NoticeBoard.Action';

        static Create = 'NoticeBoard.Action.Create';
        static Edit = 'NoticeBoard.Action.Edit';
    };

    static View = class {
        static _ = 'NoticeBoard.View';

        static Deactivated = 'NoticeBoard.View.Deactivated';
        static List = 'NoticeBoard.View.List';
    };
}
